import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

class BoxInsureds extends Component {
  render() {
    if (!this.props.plan[0]) return <div />;
    
    return (
      <div className="box box-insured">
        <div className="insureds">
          {this.props.insuredForms.map((insured, i) => (
            <div key={i}>
              <div className="insured-name">{insured.name}</div>
              <div className="insured-document">
                <strong>{insured.document_type === 'cpf' ? 'CPF' : 'Passaporte'}:</strong>
                <span>{insured.document_type === 'cpf' ? insured.cpf : insured.passport}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }
}

export default withRouter(
  connect((state) => ({
    plan: state.search.plans,
    insuredForms: state.purchase.insuredForms,
  }))(BoxInsureds)
);



// WEBPACK FOOTER //
// ./src/components/purchase/purchase_description/BoxInsureds.jsx